import {Component, Input, ViewChild} from '@angular/core';
import {EDialogOpenMode} from '../../enums/dialog-open-mode.enum';
import {PrimeNgImportsModule} from '../../prime-ng-imports';
import {GenericTableComponent} from '../generic-table/generic-table.component';
import {IBaseCRUDComponent} from '../ibase-crud/ibase-crud.component';
import {SDKQueryPaginatorConfig} from '../../services/query-paginator.service';
import {GenericTreeComponent} from '../generic-tree/generic-tree.component';

/**
 * IBaseCRUModalComponent content base
 */
@Component({
    selector: 'app-ibase-crud-content',
    templateUrl: './ibase-crud-content.component.html',
    imports: [PrimeNgImportsModule, GenericTableComponent, GenericTreeComponent]
})
export class IBaseCRUDContentComponent {
    protected readonly EDialogOpenMode = EDialogOpenMode;

    @ViewChild(GenericTableComponent)
    public genericTableComponent?: GenericTableComponent<unknown>;

    public get paginatorConfig(): SDKQueryPaginatorConfig | undefined {
        return this.genericTableComponent?.paginatorConfig;
    }

    // ===============================================================
    // ===============================================================

    @Input()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public iBaseCRUD?: IBaseCRUDComponent<any, any, any, any, any>;
    @Input()
    public mode: 'table' | 'tree' = 'table';
    @Input()
    public showTablePaginator = true;
    @Input()
    public deleteRenforced = false;
    @Input()
    public showColumnToggle = true;
    @Input()
    public showSearch = false;
    @Input()
    public showNewButton = true;
    @Input()
    public showHelpButton = false;
    @Input()
    public flexHeight = false;
    @Input()
    public defaultPaginatorConfig?: SDKQueryPaginatorConfig;

    @Input()
    public treeSelectionMode?: 'single' | 'multiple';
    @Input()
    public treeSelection: unknown;
}
